/**
 * 选择图片后压缩为较小 JPEG，输出纯 base64（无 dataURL 前缀），供上传接口使用。
 */
export function compressFileToJpegBase64(
  file: File,
  maxEdge: number,
  quality: number
): Promise<string> {
  return new Promise((resolve, reject) => {
    if (!file.type.startsWith("image/")) {
      reject(new Error("not image"));
      return;
    }
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(url);
      let { width, height } = img;
      if (width <= 0 || height <= 0) {
        reject(new Error("bad size"));
        return;
      }
      const scale = Math.min(maxEdge / width, maxEdge / height, 1);
      const w = Math.max(1, Math.round(width * scale));
      const h = Math.max(1, Math.round(height * scale));
      const canvas = document.createElement("canvas");
      canvas.width = w;
      canvas.height = h;
      const ctx = canvas.getContext("2d");
      if (!ctx) {
        reject(new Error("no ctx"));
        return;
      }
      ctx.drawImage(img, 0, 0, w, h);
      const dataUrl = canvas.toDataURL("image/jpeg", quality);
      const i = dataUrl.indexOf("base64,");
      if (i === -1) {
        reject(new Error("no base64"));
        return;
      }
      resolve(dataUrl.slice(i + "base64,".length));
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error("load fail"));
    };
    img.src = url;
  });
}
